export const CONFIG = {
  "hashKey": "dw3o292@93",
  "apiUrl": "https://stage.api.shypes.com",
  "mediaUrl": "https://stage.media.shypes.com",
  "socketServerUrl": "https://stage.socket.shypes.com",
  "enableSocket": true,
  "socketMode": "websocket",
  "baseDomain": "stage.circleplug.com"
};
